var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-captcha"},[_c('div',{staticClass:"captcha-container"},[_c('div',{staticClass:"captcha-bg",style:({ backgroundImage: 'url(' + _vm.bgImg + ')' })}),_c('div',{staticClass:"gap-mask",style:({
        left: _vm.gapX + 'px',
        top: _vm.gapY + 'px',
        width: _vm.blockW + 'px',
        height: _vm.blockH + 'px',
      })}),_c('div',{staticClass:"slider-img",style:({
        left: _vm.btnX + 'px',
        top: _vm.gapY + 'px',
        width: _vm.blockW + 'px',
        height: _vm.blockH + 'px',
        backgroundImage: 'url(' + _vm.bgImg + ')',
        backgroundPosition: -_vm.gapX + 'px ' + -_vm.gapY + 'px',
      })})]),_c('div',{staticClass:"slider-bar",class:{ success: _vm.isSuccess }},[(!_vm.isSuccess)?_c('div',{staticClass:"slider-btn",style:({ left: _vm.btnX + 'px' }),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_vm._v(" → ")]):_vm._e(),_c('span',{staticClass:"slider-text"},[_vm._v(" "+_vm._s(_vm.isSuccess ? "验证成功" : "按住滑块拖动")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }